import { gql } from '@apollo/client'

export const STARS_IN_CATEGORY_EXTENDED_QUERY = gql`
  query artistsFromCategoriesExtended(
    $first: Int
    $orderBy: String
    $status: String
    $after: String
    $activeArtworks: Boolean
    $venueCoordinates: String
    $categoryWithChild_Exact: String
    $annotateArtworkMinStartDate: Boolean
  ) {
    allArtists(
      first: $first
      after: $after
      status: $status
      orderBy: $orderBy
      venueCoordinates: $venueCoordinates
      categoryWithChild_Exact: $categoryWithChild_Exact
      activeArtworks: $activeArtworks
      annotateArtworkMinStartDate: $annotateArtworkMinStartDate
    ) {
      edges {
        node {
          id
          fullName
          file {
            extension
            path
          }
          slug
          categories {
            edges {
              node {
                id
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
export const STARS_WITH_VIP_QUERY = gql`
  query artistsWithTicketsVIP(
    $first: Int
    $orderBy: String
    $status: String
    $after: String
    $ids: String
    $activeArtworks: Boolean
  ) {
    allArtists(
      status: $status
      first: $first
      after: $after
      ids: $ids
      activeArtworks: $activeArtworks
      hasPackages: true
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          fullName
          slug

          featuredDate
          file {
            extension
            path
          }
        }
      }

      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
export const GET_STARS_BY_FOLLOWERS = gql`
  query GetStarsByFollowers($first: Int) {
    allArtists(status: "public", orderBy: "-followers", first: $first) {
      edges {
        node {
          id
          slug
          followers
          fullName
          file {
            extension
            path
          }
        }
      }
    }
  }
`
export const GET_STAR_BY_SLUG = gql`
  query GetStarBySlug($slug: String!, $status: String) {
    allArtists(slug: $slug, status: $status) {
      edges {
        node {
          id
          pk
          bio
          fullName
          lastParentCategories
          meta
          file {
            extension
            path
          }
          slug
          status
        }
      }
    }
  }
`
export const ALL_STARS_SLUG = gql`
  query GetAllArtistsSlug($status: String) {
    allArtists(status: $status) {
      edges {
        node {
          slug
        }
      }
    }
  }
`
export const GET_FEATURED_STARS = gql`
  query GetFeaturedStars($ids: String) {
    allArtists(
      status: "public"
      featuredDate_Isnull: false
      orderBy: "-featured_date"
      idsNotIn: $ids
    ) {
      edges {
        node {
          id
          fullName
          slug
          id
          file {
            extension
            path
          }
        }
      }
    }
  }
`
